import { forwardRef } from "react";
import { NinjaOneStep1 } from "./NinjaOneStep1";
import { NinjaOneStep2 } from "./NinjaOneStep2";

export const NinjaOneMainWrapper = forwardRef(
  ({ step }: { step: 1 | 2 }, ref) => {
    switch (step) {
      case 1:
        return <NinjaOneStep1 ref={ref} />;
      case 2:
        return <NinjaOneStep2 ref={ref} />;
      default:
        return <NinjaOneStep1 ref={ref} />;
    }
  },
);
